import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isBeautyApp } from '@ori/beauty-app-info';
import { LABEL_ADD_TO_BASKET_VISIBLE, LABEL_CAN_BE_RESERVED, LABEL_DEAL, LABEL_PPA } from './constants';
var findLabelByDomainType = function findLabelByDomainType(domainType) {
  return function (label) {
    return (label === null || label === void 0 ? void 0 : label.productLabelDomain) === domainType;
  };
};
var findLabelByKey = function findLabelByKey(key) {
  return function (label) {
    return (label === null || label === void 0 ? void 0 : label.labelKey) === key;
  };
};
export var filterData = function filterData(data) {
  return data != null;
};
export var filterMappedProducts = function filterMappedProducts(products) {
  return products.filter(filterData);
};
export var filterProducts = function filterProducts(products) {
  return products.filter(filterData);
};
export var filterShades = function filterShades(shades) {
  return shades.filter(filterData);
};
export var getProductUrl = function getProductUrl(code) {
  return "/products/product?code=".concat(code);
};
export var maybeMapProps = function maybeMapProps(_ref, props) {
  var currentPrice = _ref.currentPrice,
    name = _ref.name;
  if (currentPrice && name) {
    return _objectSpread(_objectSpread({}, props), {}, {
      currentPrice: currentPrice,
      hasRelatedSet: false,
      isFavoritesDisabled: isBeautyApp(),
      name: name,
      showPoints: false
    });
  }
  return null;
};
export var mapCanBeReserved = function mapCanBeReserved(collection) {
  var canBeReserved = collection === null || collection === void 0 ? void 0 : collection.find(findLabelByKey(LABEL_CAN_BE_RESERVED));
  return canBeReserved ? true : undefined;
};
export var mapCanBeSold = function mapCanBeSold(collection) {
  return (collection === null || collection === void 0 ? void 0 : collection.find(findLabelByKey(LABEL_ADD_TO_BASKET_VISIBLE))) !== undefined;
};
export var mapLabels = function mapLabels(collection) {
  if (collection) {
    var _deal$labelKey, _deal$title, _flag$labelKey, _flag$title;
    var deal = collection.find(findLabelByDomainType(LABEL_DEAL));
    var flag = collection.find(findLabelByDomainType(LABEL_PPA));
    return {
      labelDealFlag: (_deal$labelKey = deal === null || deal === void 0 ? void 0 : deal.labelKey) !== null && _deal$labelKey !== void 0 ? _deal$labelKey : null,
      labelDealString: (_deal$title = deal === null || deal === void 0 ? void 0 : deal.title) !== null && _deal$title !== void 0 ? _deal$title : null,
      labelFlag: (_flag$labelKey = flag === null || flag === void 0 ? void 0 : flag.labelKey) !== null && _flag$labelKey !== void 0 ? _flag$labelKey : null,
      labelString: (_flag$title = flag === null || flag === void 0 ? void 0 : flag.title) !== null && _flag$title !== void 0 ? _flag$title : null
    };
  }
  return {
    labelDealFlag: null,
    labelDealString: null,
    labelFlag: null,
    labelString: null
  };
};
export var mapShade = function mapShade(_ref2) {
  var colorHexCode = _ref2.colorHexCode,
    colorImageUrl = _ref2.colorImageUrl,
    productCode = _ref2.productCode;
  var props = {
    productCode: productCode !== null && productCode !== void 0 ? productCode : ''
  };
  if (colorHexCode) {
    props.hexColors = colorHexCode.split(',');
  }
  if (colorImageUrl) {
    props.imageUrl = colorImageUrl;
  }
  return props;
};
export var mapShades = function mapShades(shades) {
  if (shades) {
    return filterShades(shades).map(mapShade);
  }
  return undefined;
};